import React, { useContext, useState } from 'react';
import { Trans } from '@lingui/macro';

import ShowMoreButton from '../ShowMoreButton/ShowMoreButton';
import './AboutContent.pcss';
import ViewportContext from '../Viewport/ViewportContext';
import InfoAboutServiceModal from '../InfoAboutServiceModal/InfoAboutServiceModal';
import Link from '../../shared/Link/Link';
import { i18n } from '../../../helpers/i18n';
import {
  aboutServiceTexts,
  needToKnow,
} from '../../../constants/iterableTexts';

const MOBILE_WIDTH = 768;

interface LinkProps {
  url: string;
  name: string;
}

function About(): JSX.Element {
  const { windowWidth } = useContext(ViewportContext);
  const [openFull, setOpenFull] = useState(false);
  const showButton = windowWidth < MOBILE_WIDTH;
  return (
    <div className="About__grid">
      <div className="About__column About__column_left">
        <div className="About__content">
          <div className="About__header">
            <Trans>Об услуге</Trans>
          </div>
          <div>
            {aboutServiceTexts.map((t, key) => {
              return (
                <span className="About__text" key={key}>
                  <Trans id={t} />
                </span>
              );
            })}
            {showButton && (
              <ShowMoreButton onClick={setOpenFull} isOpen={openFull} />
            )}
          </div>
          <InfoAboutServiceModal />
        </div>
      </div>
      <div className="About__column About__column_right">
        <div className="About__header">
          <Trans>Важно знать</Trans>
        </div>
        <div className="About__content">
          {needToKnow.map(({ url, name }: LinkProps, index) => {
            return (
              <p key={index + name}>
                <Link key={index} href={i18n._(url)} target="_blank">
                  <Trans id={name} />
                </Link>
              </p>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default About;
